var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationPin3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "-0.5 -0.5 14 14",
    height: 14,
    width: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "location-pin-3--navigation-map-maps-pin-gps-location"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fill: "#ffffff",
    d: "m1.583214285714286 9.790857142857144 -1.0585714285714285 2.068857142857143a0.4642857142857143 0.4642857142857143 0 0 0 0.4122857142857143 0.676h11.119642857142857a0.4642857142857143 0.4642857142857143 0 0 0 0.41135714285714287 -0.6787857142857143l-1.0799285714285716 -2.071642857142857a0.9285714285714286 0.9285714285714286 0 0 0 -0.8236428571428572 -0.4995714285714286H2.4096428571428574a0.9285714285714286 0.9285714285714286 0 0 0 -0.8264285714285715 0.5051428571428572Z",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2050",
    fill: "#fdba74",
    d: "M6.553857142857143 0.4642857142857143h-0.10864285714285715a4.329 4.329 0 0 0 -4.317857142857143 4.020714285714286c-0.07985714285714285 1.1040714285714286 0.16992857142857143 2.2239285714285715 0.8403571428571429 3.104214285714286 0.8375714285714286 1.100357142857143 1.6890714285714286 1.8617857142857142 3.033642857142857 2.7634285714285713a0.8960714285714285 0.8960714285714285 0 0 0 0.9963571428571428 0c1.3455000000000001 -0.9007142857142857 2.196071428571429 -1.6621428571428571 3.0345714285714287 -2.7634285714285713 0.6704285714285714 -0.8802857142857142 0.9192857142857143 -2.000142857142857 0.8403571428571429 -3.104214285714286A4.329 4.329 0 0 0 6.554785714285715 0.4642857142857143Z",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    stroke: "#f97316",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.502142857142857 9.285714285714286h0.06221428571428572a0.9285714285714286 0.9285714285714286 0 0 1 0.8236428571428572 0.4995714285714286l1.0799285714285716 2.0707142857142857a0.4642857142857143 0.4642857142857143 0 0 1 -0.41135714285714287 0.6797142857142857H0.9369285714285713a0.4642857142857143 0.4642857142857143 0 0 1 -0.41321428571428576 -0.676l1.0585714285714285 -2.068857142857143A0.9285714285714286 0.9285714285714286 0 0 1 2.4105714285714286 9.285714285714286h0.06035714285714286",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2051",
    stroke: "#f97316",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.553857142857143 0.4642857142857143h-0.10864285714285715a4.329 4.329 0 0 0 -4.317857142857143 4.020714285714286c-0.07985714285714285 1.1040714285714286 0.16992857142857143 2.2239285714285715 0.8403571428571429 3.104214285714286 0.8375714285714286 1.100357142857143 1.6890714285714286 1.8617857142857142 3.033642857142857 2.7634285714285713a0.8960714285714285 0.8960714285714285 0 0 0 0.9963571428571428 0c1.3455000000000001 -0.9007142857142857 2.196071428571429 -1.6621428571428571 3.0345714285714287 -2.7634285714285713 0.6704285714285714 -0.8802857142857142 0.9192857142857143 -2.000142857142857 0.8403571428571429 -3.104214285714286A4.329 4.329 0 0 0 6.554785714285715 0.4642857142857143Z",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fill: "#ffffff",
    d: "M6.5 6.035714285714286c0.8914285714285715 0 1.3928571428571428 -0.5014285714285714 1.3928571428571428 -1.3928571428571428S7.3914285714285715 3.25 6.5 3.25 5.107142857142858 3.751428571428572 5.107142857142858 4.642857142857143 5.6085714285714285 6.035714285714286 6.5 6.035714285714286Z",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    stroke: "#f97316",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.5 6.035714285714286c0.8914285714285715 0 1.3928571428571428 -0.5014285714285714 1.3928571428571428 -1.3928571428571428S7.3914285714285715 3.25 6.5 3.25 5.107142857142858 3.751428571428572 5.107142857142858 4.642857142857143 5.6085714285714285 6.035714285714286 6.5 6.035714285714286Z",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPin3);
export default __webpack_public_path__ + "static/media/location-pin-3.ae2ea5481de1ae90c6f85d3fd1b45201.svg";
export { ForwardRef as ReactComponent };